import styled from 'styled-components';
import {device} from '@guestapp/ui/src/utils/device';
import CustomIcon from '@guestapp/ui/src/components/CustomIcon';
import {Box, Hr, MainButton} from 'styled/common';

export const Wrapper = styled.div`
  padding: 16px 0;
  width: 100%;
`;

export const WelcomeText = styled.div`
  text-align: left;
  width: 100%;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 120% */
  letter-spacing: 0.36px;
  margin-bottom: 16px;
`;

export const StyledBox = styled(Box)`
  width: 100%;
  height: auto;
  padding: 24px 16px;
  @media (min-width: ${device.tablet}) {
    padding: 24px;
  }
`;

export const BoxTitle = styled.div`
  font-family: inherit;
  font-size: ${props => props.theme.fontSizes.$big};
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.36px;
  color: ${props => props.theme.colors.$fontBlack};
  margin-bottom: 24px;
`;

export const TaskInfoContainer = styled.div`
  @media (min-width: ${device.laptopM}) {
    display: flex;
    justify-content: space-between;
  }
`;

export const MobileMainButton = styled(MainButton)`
  width: 200px;
  min-width: 100%;
  max-width: 100%;
  justify-content: center;
  & .button__right-icon {
    display: none;
  }
  @media (min-width: ${device.laptopM}) {
    display: none;
  }
`;

export const DesktopMainButton = styled(MainButton)`
  display: none;
  @media (min-width: ${device.laptopM}) {
    display: flex;
    margin: 0;
    max-width: 70%;
    justify-content: center;

    & .buttonLabel {
      font-weight: 400;
    }

    & .button__right-icon {
      margin-top: -5px;
    }
  }
  @media (min-width: ${device.laptopL}) {
    max-width: 80%;
  }
`;

export const StyledHr = styled(Hr)`
  @media (min-width: ${device.laptopM}) {
    display: none;
  }
`;

export const BookingAndButtonContainer = styled.div`
  @media (min-width: ${device.laptopM}) {
    width: 425px;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
`;

export const TasksPanelContainer = styled.div`
  margin-bottom: 24px;
  width: auto;

  @media (min-width: ${device.laptopL}) {
    width: 560px;
    margin-bottom: 0;
  }
`;
export const StyledIcon = styled(CustomIcon)`
  transform: rotate(180deg);
`;
